export function createId(prefix: string): string {
  const rand = crypto.randomUUID().slice(0, 8);
  return `${prefix}-${rand}`;
}
